import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';
import StaticHeader from '../../utils/StaticHeader';

import livros from '../../assets/livros.png';

export default function Warning(props) {
  const { mensagem } = props;

  return (
    <StaticHeader
      version={props.version}
      setLoading={props.setLoading}
      handleMessage={props.handleMessage}
      error={props.error}
      setError={props.setError}
      naoExibirMenu={props.naoExibirMenu}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          marginTop: { xs: '-140px', sm: 0 },
        }}>
        <Box
          sx={{
            width: 300,
            height: 380,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'top',
            textAlign: 'center',
            backgroundImage: `url(${livros})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
          }}>
            {mensagem}
            <Button
              color="branca"
              variant="contained"
              sx={{ mt: 1 }}
              onClick={()=>{
                window.location.pathname = '/';
              }}
              startIcon={<ReplayIcon />}>
              Voltar à página inicial
            </Button>
        </Typography>
        </Box>
      </Box>
    </StaticHeader>
  );
}
